
const initBlogSlider = () => {
  const postSlider = document.querySelector('.blog-slider');

  if (!postSlider) return;

  const previousBtn = document.querySelector('.blog-previous-btn');
  const nextBtn = document.querySelector('.blog-next-btn');

  const previousSliderBtn = document.getElementById('blog-previous-btn-slidenav');
  const nextSliderBtn = document.getElementById('blog-next-btn-slidenav');

  previousBtn.addEventListener('click', () => {
    previousSliderBtn.click();
  });

  nextBtn.addEventListener('click', () => {
    nextSliderBtn.click();
  });
};

export default initBlogSlider;
